module.exports = __webpack_public_path__ + "media/images/package-0d54bfa3.png";